import { EntitySectionLayout } from "@/shared/components/common/EntitySectionLayout";
import { TenantsHeader } from "./TenantsHeader";
import { TENANTS_LISTING_CONFIG } from "../constants/listingConfig";

export function TenantsLayout() {
  return (
    <EntitySectionLayout
      basePath={TENANTS_LISTING_CONFIG.basePath}
      HeaderComponent={TenantsHeader}
      hideHeaderMatchers={["add", "edit/"]}
    />
  );
}
